import { memo } from 'react';
import { Button } from '@mui/material';
import LanguageSelector from './LanguageSelector';
import { LanguageIcon } from 'components/icons/LanguageIcon';

const LanguageButton = () => {
  return (
    <LanguageSelector
      component={Button}
      mini
      compProps={{ variant: 'text', color: 'secondary' }}
      icon={<LanguageIcon color='primary' fontSize='small' />}
    />
  );
};

export default memo(LanguageButton);
